<template>
    <el-dialog
        title="   "
        :visible.sync="value"
        v-if="value"
        width="640px"
        :custom-class="classNames"
        @close="handleClose">
        <div :class="classNames+ '_con'">
            <steps :active="2" v-if="!isHasSlots">
                <step status="success">
                    <span slot="title" style="color: #333">发起提现申请</span>
                </step>
                <step status="waiting">
                    <div slot="title">
                        <p style="color: #1677FF;">等待处理</p>
                        <p style="font-size:14px;color: #999">预计3个工作日到账</p>
                    </div>
                </step>
                <step status="default" title="到账成功"></step>
            </steps>
            <slot name="content"></slot>
            <div :class="classNames+ '_line'"></div>
            <ul :class="classNames+'_ul'">
                <li v-for="(item, index) in list" :key="index">
                    <span>{{item.label}}</span>
                    <p>
                        <span>{{dataObj[item.value]}}</span>
                    </p>
                </li>
            </ul>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit" class="btn-108-32">完成</el-button>
        </span>
    </el-dialog>

</template>
<script>
import steps from '@/components/step/steps.vue'
import step from '@/components/step/step.vue'
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        dataObj: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            classNames: 'withdrawalResDialog',
            list: [
                {
                    label: '提取金额',
                    value: 'amount'
                },
                {
                    label: '到账账户',
                    value: 'account'
                }
            ]
        }
    },
    components: {
        step,
        steps
    },
    computed: {
        isHasSlots() {
           let flag = this.$scopedSlots?.$hasNormal
           return flag
       }
    },
    methods: {
        handleClose() {
            this.$emit('input', false)
        },
        submit() {
            this.$emit('input', false)
            this.$emit('sure')
        }
    }
}
</script>
<style lang="less">
    @classNames: withdrawalResDialog;
    .@{classNames} {
        .@{classNames}_con {
            padding-left: 130px;
        }
        .el-dialog__header {
            border-bottom: 1px solid #EEEEEE;
            height: 30px;
        }
        .el-dialog__footer {
            display: flex;
            justify-content: center;
            border-top: 1px solid #EEEEEE;
        }
        .@{classNames}_line {
            width: 340px;
            height: 1px;
            background: #EEEEEE;
            margin-top: 49px;
            margin-bottom: 20px;
        }
        .@{classNames}_ul {
            width: 340px;
            li {
                display: flex;
                justify-content: space-between;
                font-size: 16px;
                line-height: 22px;
                &:not(:last-child) {
                    margin-bottom: 16px;
                }
                >span {
                    color: #999999;
                }
                p {
                    color: #333333;
                }
            }
        }
    }
</style>